import { Stem, StemLineChart } from "@examspark/types";

import { getNewScore } from "..";

export const scoreLineChart = (
  expected: StemLineChart,
  actual: Partial<Stem.Response>,
) => {
  const { scoring, config, content } = expected;
  const score = getNewScore();
  score.max = scoring.data.length || 1;

  if (!actual) return score;
  if (!actual.chart) return score;

  for (let index = 0; index < scoring.data.length; index++) {
    const expectedValue = Number(scoring.data[index].value);
    const actualValue = Number(actual.chart[index].value);

    if (expectedValue === actualValue) {
      score.actual++;
    }
  }

  return score;
};
